import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppClientRoot/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ZendeskChatbotProvider"] */ "/app/src/contexts/zendesk-chatbot-context/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/themes/spring/primary/index.css");
